import { dictionaryLookup, mapTagInfo } from '../Tags';
export class MetaDataIterator {
    constructor(metadata) {
        this.metadata = metadata;
    }
    syncIterator(listener, object = this.metadata) {
        for (const [key, value] of Object.entries(object)) {
            if (key === '_vrMap' || value === undefined) {
                continue;
            }
            if (value === null) {
                listener.addTag(key, { length: 0 });
                listener.pop();
                continue;
            }
            const vr = value.vr;
            const tagData = mapTagInfo.get(key);
            const dictEntry = !tagData ? dictionaryLookup(key) : undefined;
            const hasBulk = !value.Value &&
                (value.BulkDataURI ??
                    value.InlineBinary);
            if (!value.Value && !hasBulk) {
                continue;
            }
            listener.addTag(key, {
                vr,
                name: tagData?.name || dictEntry?.name,
                vm: tagData?.vm ?? dictEntry?.vm,
            });
            if (vr === 'SQ') {
                for (const v of value.Value) {
                    listener.startObject();
                    this.syncIterator(listener, v);
                    listener.pop();
                }
                listener.pop();
                continue;
            }
            if (hasBulk) {
                listener.value({
                    BulkDataURI: value.BulkDataURI,
                    InlineBinary: value.InlineBinary,
                });
                listener.pop();
                continue;
            }
            if (value.vr === 'CS' &&
                value.Value.length === 1 &&
                String(value.Value[0]).indexOf('\\') !== -1) {
                value.Value = String(value.Value[0]).split('\\');
            }
            for (const v of value.Value) {
                listener.value(v);
            }
            listener.pop();
        }
    }
}
